import { render, staticRenderFns } from "./reportsIndex.vue?vue&type=template&id=278f2130&"
import script from "./reportsIndex.vue?vue&type=script&lang=js&"
export * from "./reportsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports